import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "headerTitle"]

  connect () {
    this.syncTitle()
  }

  syncTitle () {
    if (!this.hasNameInputTarget || !this.hasHeaderTitleTarget) return

    const value = this.nameInputTarget.value.trim()
    this.headerTitleTarget.textContent = value || this.nameInputTarget.placeholder || ""
  }
}
